import { render } from "./CardProduct.vue?vue&type=template&id=5bbd28c1&scoped=true"
import script from "./CardProduct.vue?vue&type=script&lang=js"
export * from "./CardProduct.vue?vue&type=script&lang=js"

import "./CardProduct.vue?vue&type=style&index=0&id=5bbd28c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbd28c1"]])

export default __exports__